import { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import ArrowRightIcon from '@svg/arrows-right.svg';
import { useAppContext } from '@contexts/AppContext';
import { LocalizedLink } from '@ui/LocalizedLink';

import s from './MenuLevel.sss';

interface CatalogTree {
  id: number,
  name: string,
  slug: string,
  subCatalogs: CatalogTree[],
}

type MenuLevelProps = {
  subCatalogsData: CatalogTree[];
  activeLevelUrl?: string;
  className?: string;
};

export const MenuLevel: React.FC<MenuLevelProps> = ({
  subCatalogsData,
  activeLevelUrl,
  className,
}) => {
  const history = useHistory();
  const [activeLevel, setActiveLevel] = useState<CatalogTree>();

  const { isOutlet } = useAppContext();

  const handleMenuItemClick = (catalog: CatalogTree) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (isOutlet) {
      e.preventDefault();

      history.push(`/${activeLevelUrl}/${catalog.slug}`);
    }
  };

  return (
    <div className={classNames(s.root, className)} onMouseLeave={() => setActiveLevel(undefined)}>
      <div className={s.links}>
        {
          subCatalogsData.map(
            (level) => (
              <LocalizedLink
                key={level.slug}
                className={classNames(s.link, { [s.hovered]: level.slug === activeLevel?.slug })}
                href={`/${activeLevelUrl}/${level.slug}`}
                onClick={handleMenuItemClick(level)}
                onMouseEnter={() => setActiveLevel(level)}
              >
                {level.name}
                {
                  !!level?.subCatalogs?.length
                  && (
                    <ArrowRightIcon
                      className={s.arrow}
                      width='24'
                      height='24'
                    />
                  )
                }
              </LocalizedLink>
            ),
          )
        }
      </div>

      {!!activeLevel?.subCatalogs?.length && (
         
        <MemoizedMenuLevel
          key={activeLevel.slug}
          subCatalogsData={activeLevel.subCatalogs}
          activeLevelUrl={activeLevelUrl}
        />
      )}
    </div>
  );
};

export const MemoizedMenuLevel = memo(
  MenuLevel,
  (prevProps, nextProps) => (
    prevProps.activeLevelUrl === nextProps.activeLevelUrl
    && prevProps.className === nextProps.className
  ),
);
